"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=event-config.js.map